import { render, staticRenderFns } from "./co-urging-query.vue?vue&type=template&id=93ba8692"
import script from "./co-urging-query.vue?vue&type=script&lang=ts"
export * from "./co-urging-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports